import { useCallback, useMemo } from "react";

import { Filter, FilterId, FilterType } from "@/Components/v2/organism/Header/Header";
import { useInfo } from "@/context/InfoProvider/InfoProvider";

import { useSalesDriversStore } from "./store/useSalesDriversStore";

export const useAvailableFilters = () => {
  const { setTargetNode, setGeography } = useSalesDriversStore();
  const { filters } = useSalesDriversStore((state) => state);
  const { initInfo: info } = useInfo();
  const [geoData] = info?.geographies || [];

  const handleTargetNodeChange = useCallback(
    (targetNode: string | null) => {
      setTargetNode(targetNode);
    },
    [setTargetNode]
  );

  const handleGeographiesChange = useCallback(
    (geography: string[]) => setGeography(geography),
    [setGeography]
  );

  // Memoize each filter option separately
  const targetNodeFilter = useMemo(
    () => ({
      id: FilterId.BusinessUnit,
      label: "Business Unit",
      type: FilterType.BusinessUnit,
      value: filters.targetNodeUUID,
      onChange: handleTargetNodeChange,
    }),
    [filters.targetNodeUUID, handleTargetNodeChange]
  );

  const geographiesFilter = useMemo(
    () => ({
      id: FilterId.Geography,
      label: "Geo",
      type: FilterType.MultiSelect,
      value: filters.geography,
      onChange: handleGeographiesChange,
    }),
    [filters.geography, handleGeographiesChange]
  );

  return useMemo(() => {
    const filters: Filter[] = [targetNodeFilter];
    if (geoData && geoData.length > 0) {
      filters.push(geographiesFilter);
    }
    return filters;
  }, [targetNodeFilter, geographiesFilter, geoData]);
};
